import { TreeViewModel } from "@genexus/chameleon-controls-library";
import { NavigationData, Status } from "./navigation-report";

export const STATUS_REGEXP_KEY = "status";
export const CAPTION_REGEXP_KEY = "caption";

export const mapNavigationDataToTreeView = (
  navigationData: NavigationData[]
): TreeViewModel =>
  navigationData.map((dataItem, i) => {
    return {
      id: dataItem.id,
      selected: i === 0,
      caption: dataItem.name,
      startImgSrc: dataItem.icon,
      parts: `tree-view-item tree-view-item--status tree-view-item--${dataItem.result}`,
      leaf: true,
      metadata: JSON.stringify({
        [STATUS_REGEXP_KEY]: dataItem.result.toString() as Status,
        [CAPTION_REGEXP_KEY]: dataItem.name
      })
    };
  });
